import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";
import {
  fontWeightBold,
  h3Regular,
} from "../../../../components/typography/MuiTypography.style";

export const ViewProgramTemplateProfileWrapper = styled.div`
  background-color: ${COLORS.cirrus_white};

  .MuiGrid2-root {
    padding-right: 8px;
    padding-left: 8px;
    ${responsive.MOBILE`
      padding-right: 0px;
      padding-left: 0px;
    `}
  }

  .main-container {
    width: 100%;
    padding: 24px 8px 16px;
    ${responsive.TABLET_PORTRAIT`
      padding: 24px 8px;
    `}
    ${responsive.MOBILE`
      padding: 0 8px 16px 8px;
    `}

    .MuiTypography-h3SemiBold {
      line-height: 19.36px;
      color: ${COLORS.primary_light_blue};
    }
  }

  .view-locale-link {
    ${h3Regular}
    ${fontWeightBold}
    text-decoration: underline;
    text-underline-offset: 4px;
    color: ${COLORS.primary_light_blue};
  }
`;
